"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelToCapitalizedConverter = void 0;
var capitalize_1 = require("./capitalize");
var camelToCapitalizedConverter = function (string) {
    return (0, capitalize_1.capitalizeConverter)(string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, function (x) { return "".concat(x[0]).concat(' ' + x.toUpperCase()[1]); }));
};
exports.camelToCapitalizedConverter = camelToCapitalizedConverter;
//# sourceMappingURL=camelToCapitalized.js.map